import { UserApi } from './';

const {REACT_APP_API_BASE_URL} = process.env;

export class CreateEventApi {
    static create (data) {
        return fetch(`${REACT_APP_API_BASE_URL}/api/me/events`, {
            ...UserApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/createEvent.js